import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
import { Page } from './Page';
/*================================

Pamphlet Class

================================*/
export class Pamphlet {
    constructor(zoom) {//読み込む外部Page
        this.zoom = zoom;
        this.pageList = [
            [null,'page1.html'],
            ['page2.html','page3.html'],
            ['page4.html','page5.html'],
            ['page6.html','page7.html'],
            ['page8.html','page9.html'],
            ['page10.html','page11.html'],
            ['page12.html','page13.html'],
            ['page14.html','page15.html'],
            ['page16.html','page17.html'],
            ['page18.html','page19.html'],
            ['page20.html','page21.html'],
            ['page22.html','page23.html'],
            ['page24.html','page25.html'],
            ['page26.html','page27.html'],
            ['page28.html','page29.html'],
            ['page30.html','page31.html'],
            ['page32.html','page33.html'],
            ['page34.html','page35.html'],
            ['page36.html','page37.html'],
            ['page38.html','page39.html'],
            ['page40.html','page41.html'],
            //['page40.html',null],
        ];
        this.singlePageList = [];
        this.isSides = -1;
        this.isEnable = true;
        //this.isZoom = false;
        this.currentPageNum = 0;
        this.wrapperW = null;
        this.maxPageNum = this.pageList.length;
        this.pageW = 1570;
        this.pageH = 2220;
        this.dist = 'pages/';
        this.sp = 0.3;
        this.dir = 'right';
        this.wrapper = document.querySelector('.wrapper');
        this.pamph = document.querySelector('#Pamphlet');
        this.book = document.querySelector('.book');
        this.bookItem = document.querySelectorAll('.book__item');
        //this.bookInner = document.querySelector('.js-book-inner');
        this.bookSides = document.querySelector('.js-book-sides');
        this.bookSingle = document.querySelector('.js-book-single');
        this.pageRight = document.querySelector('.js-page-right');
        this.pageLeft  = document.querySelector('.js-page-left');
        this.pageRightPrev = document.querySelector('.js-page-right-prev');
        this.pageLeftPrev  = document.querySelector('.js-page-left-prev');
        this.pageRightNext = document.querySelector('.js-page-right-next');
        this.pageLeftNext  = document.querySelector('.js-page-left-next');
        this.pageLeftClone = document.querySelector('.js-page-left-clone');
        this.pageRightClone = document.querySelector('.js-page-right-clone');
        this.pageSingleCurrent = document.querySelector('.js-single-page-current');
        this.pageSingleNext = document.querySelector('.js-single-page-next');
        this.pageSinglePrev = document.querySelector('.js-single-page-prev');
        this.pageSingleClone = document.querySelector('.js-single-page-clone');
        this.pageNum = document.querySelector('.js-page-num');

        this.nextTL = gsap.timeline();
        this.prevTL = gsap.timeline();

        this.nextSingleTL = gsap.timeline();
        this.prevSingleTL = gsap.timeline();
        this.linkCount = 0;

        this.init();

    }

    //初期
    init() {
        this.singlePageList = this.pageList.reduce((a,b) => {
            return a.concat(b);
        });

        gsap.ticker.fps(90);
        this.setPageTurn();
        this.setPageTurnSingle();
        this.setSize();

        window.addEventListener('resize',() => {
            this.setSize();
        });

        const observer = new MutationObserver(() => {
            this.setSize();
        });

        observer.observe(this.wrapper,{attributes: true});

        this.nextTL.to(this.pageRight,{
            rotateY: '-90deg',
            duration: this.sp,
            filter:'brightness(80%)',
            ease: Sine.easeIn,
            onReverseComplete: () => {
                this.nextTL.progress(0).pause();
            }
        }).to(this.pageLeftNext,{
            rotateY: '0deg',
            filter:'brightness(100%)',
            duration: this.sp,
            ease: Sine.easeOut,
            onComplete: () => {
                this.setSidesPage(this.currentPageNum);
                this.nextTL.progress(0).pause();
                this.prevTL.progress(0).pause();
            }
        }).pause();


        this.prevTL.to(this.pageLeft,{
            rotateY: '90deg',
            duration: this.sp,
            filter:'brightness(80%)',
            ease: Sine.easeIn,
            onReverseComplete: () => {
                this.prevTL.progress(0).pause();
            }
        }).to(this.pageRightPrev,{
            rotateY: '0deg',
            filter:'brightness(100%)',
            duration: this.sp,
            ease: Sine.easeOut,
            onComplete: () => {
                this.setSidesPage(this.currentPageNum);
                this.nextTL.progress(0).pause();
                this.prevTL.progress(0).pause();
                /*this.nextTL.clear();
                this.prevTL.clear();*/
            }
        }).pause();

        this.nextSingleTL.to(this.pageSingleCurrent,{
            opacity: 0,
            x: -100,
            y: -5,
            scale: 1.02,
            duration: this.sp * 2,
            onReverseComplete: () => {
                this.nextSingleTL.progress(0).pause();
            }
        }).to(this.pageSingleNext,{
            opacity:1,
            x:0,
            y:0,
            scale:1,
            duration:this.sp * 1.5,
            delay: -(this.sp * 1.5),
            onComplete: () => {
                this.setSinglePage(this.currentPageNum);
                this.nextSingleTL.progress(0).pause();
                this.prevSingleTL.progress(0).pause();
            }
        }).pause();

        this.prevSingleTL.set(this.pageSinglePrev,{zIndex:3})
        .to(this.pageSingleCurrent,{
            opacity: 0,
            x: 100,
            y: 5,
            scale: 0.98,
            duration: this.sp * 2,
            onReverseComplete: () => {
                this.prevSingleTL.progress(0).pause();
            }
        }).to(this.pageSinglePrev,{
            opacity:1,
            x:0,
            y:0,
            scale:1,
            duration:this.sp * 1.5,
            delay: -(this.sp * 1.5),
            onComplete: () => {
                this.setSinglePage(this.currentPageNum);
                this.nextSingleTL.progress(0).pause();
                this.prevSingleTL.progress(0).pause();
            }
        }).pause();
    }
    //何ページ目かを表示
    setPageNum() {
        this.pageNum.innerHTML = (this.currentPageNum + 1) + '/' + this.maxPageNum;

    }

    //ページの横幅を取得
    getPageW() {
        return this.pageLeft.clientWidth ? this.pageLeft.clientWidth : this.pageRight.clientWidth;
    }

    //ページの高さを取得
    getPageH() {
        return  this.pageLeft.clientHeight ? this.pageLeft.clientHeight : this.pageRight.clientHeight;
    }

    //ページの横幅を取得
    getSinglePageW() {
        return this.pageSingleCurrent.clientWidth;
    }

    //ページの高さを取得
    getSiglePageH() {
        return this.pageSingleCurrent.clientHeight;
    }
    //ブラウザの比率を取得
    getMedia() {
        const ww = this.wrapper.clientWidth;//window.innerWidth;
        const wh = window.innerHeight;
        const isBrowser = this.pageH/(this.pageW * 2) < (wh/ww) * 0.85;
        return isBrowser
    }

    //単体のページ数を取得
    getSingleNum(n) {
        const p1 = this.dir === 'left' ? 0 : 1;
        const p2 = n * 2 + p1;
        return p2;

    }

    /*=======================================

    本のサイズを調整

    =======================================*/
    setSize() {
        const ww = this.wrapper.clientWidth;//window.innerWidth;
        if(ww === this.wrapperW) return;
        this.wrapperW = ww;
        const wh = window.innerHeight;
        const ratio = this.pageH/this.pageW;

        const pw = this.getSinglePageW();
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);


        const bookWidth = (w) =>{
            for(const elem of this.bookItem) {
                elem.style.width = w;
            }
        }
        const bookTop = (t) => {
            for(const elem of this.bookItem) {
                elem.style.top = t;
            }
        }
        const bookLeft = (l) => {
            for(const elem of this.bookItem) {
                elem.style.left = l;
            }
        }
        bookWidth('');
        bookTop('');
        bookLeft('');


        if(this.getMedia()) {
            if(this.isSides) this.setSinglePage(this.currentPageNum);
            this.isSides = false;
            this.bookSingle.removeAttribute('style');
            this.bookSides.style.display = 'none'


            if(ww - 40 < pw) {
                bookWidth(ww - 40 + 'px');
            }
            const pw2 = this.getSinglePageW();
            const ph2 = pw2 * ratio;

            //bookTop(-(ph2/2) - 28 + 'px');
            if(window.innerWidth < 768) {
                bookTop(-(ph2/2) - 28 + 'px');
            } else {
                bookTop('');
            }

            bookLeft(-pw2/2 + 'px');
        } else {
            if(!this.isSides || this.isSides === -1) this.setSidesPage(this.currentPageNum);
            this.isSides = true;
            bookWidth('');
            bookTop('');
            this.bookSides.removeAttribute('style');
            this.bookSingle.style.display = 'none'
        }
    }


    /*=======================================

    次のページへめくる

    =======================================*/
    startNextTurn() {
        //if(!this.isEnable) return;
        //this.isEnable = false;
        const left = this.pageLeftNext.querySelector('.page');
        const right = this.pageRightNext.querySelector('.page');
        if(left) this.pageLeftClone.appendChild(left.cloneNode(true));
        if(right) this.pageRightClone.appendChild(right.cloneNode(true));
        this.zoom.zoomout();
        this.nextTL.play();
    }

    /*=======================================

    片方ページ次のページへめくる

    =======================================*/
    startNextTurnSingle() {
        const clone = this.pageSingleNext.querySelector('.page');
        if(clone) this.pageSingleClone.appendChild(clone.cloneNode(true));
        //if(clone) this.pageSingleClone.innerHTML = clone.outerHTML;

        this.zoom.zoomout();
        this.nextSingleTL.play();

    }

    /*=======================================

    前のページへめくる

    =======================================*/
    startPrevTurn() {
        //if(!this.isEnable) return;
        const left = this.pageLeftPrev.querySelector('.page');
        const right = this.pageRightPrev.querySelector('.page');
        if(left) this.pageLeftClone.appendChild(left.cloneNode(true))
        if(right) this.pageRightClone.appendChild(right.cloneNode(true));
        this.zoom.zoomout();
        this.prevTL.play();
    }

    /*=======================================

    片方ページ前のページへめくる

    =======================================*/
    startPrevTurnSingle() {
        const clone = this.pageSinglePrev.querySelector('.page');
        if(clone) this.pageSingleClone.appendChild(clone.cloneNode(true));
        this.zoom.zoomout();
        this.prevSingleTL.play();
    }

    /*=======================================

    ボタンを有効化

    =======================================*/
    btnActive(elem) {
        const buttons = elem.querySelectorAll('button');
        for(let i = 0; i < buttons.length;i++) {
            const button = buttons[i];
            button.addEventListener('click',(e) => {
                const type = button.dataset.type;
                if(type === 'jump' && this.zoom.dragDistance < 2) {
                    this.pageJump(Number(button.dataset.target),button.dataset.page);
                }
                e.stopPropagation();
            });
        }
        const links = elem.querySelectorAll('a');
        for(let l = 0; l < links.length;l++) {
            const link = links[l];
            //this.linkCount++;
           // console.log(this.linkCount)
            link.addEventListener('click',(e) => {
                e.stopPropagation();
                if(this.zoom.dragDistance >= 2) e.preventDefault();
                return false;
            });
        }
    }


    /*=======================================

    片面ページを読み込む

    =======================================*/
    setSinglePage(n) {
        if(n === 0) {
            this.dir = 'right';
        };

        gsap.set(this.pageSingleClone,{opacity:1,zIndex:5});
        const p = this.getSingleNum(n);

        const loadListCurrent = this.singlePageList[p];
        const loadListPrev = this.singlePageList[p - 1];
        const loadListNext = this.singlePageList[p + 1];
        const loadList = [loadListPrev,loadListCurrent,loadListNext];
        const targetList = [
            this.pageSinglePrev,
            this.pageSingleCurrent,
            this.pageSingleNext
        ]
        const event = new Event('pageload');
        this.book.dispatchEvent(event);
        let loadCompNum = 0;



        //読み込み完了
        const loadEnd = () => {
            loadCompNum++;
            if(loadCompNum === loadList.length) {
                this.isEnable = true;
                this.currentPageNum = n;
                gsap.set(this.pageSinglePrev,{zIndex:1,opacity:0,x:-100,y:-5,scale:1.02});
                gsap.set(this.pageSingleCurrent,{zIndex:2,opacity:1,x:0,y:0,scale:1});
                gsap.set(this.pageSingleNext,{zIndex:1,opacity:0, x: 100,y:5,scale: 0.98 });
                gsap.set(this.pageSingleClone,{opacity:0});
                this.pageSingleClone.innerHTML = '';
                this.btnActive(this.pageSingleCurrent);
                const leftTurnArea = this.pageSingleCurrent.querySelector('.js-turn-area-left');
                const rightTurnArea = this.pageSingleCurrent.querySelector('.js-turn-area-right');
                if(!(this.currentPageNum === 0 && this.dir === 'right')) {
                    leftTurnArea.classList.add('pointer');
                    leftTurnArea.addEventListener('click',() => {
                        if(this.zoom.isZoom) return;
                        this.pagePrev();
                    });
                }
                if(!(this.currentPageNum === this.maxPageNum-1 && this.dir === 'right')){
                    rightTurnArea.classList.add('pointer');
                    rightTurnArea.addEventListener('click',() => {
                        if(this.zoom.isZoom) return;
                        this.pageNext();
                    });

                }


                //初期の状態にする
               //this.setPageNum();
            }
        }

        //読み込み開始
        const loadStart = () => {
            gsap.set(this.pageSingleCurrent,{opacity:0});
            //gsap.set(this.pageSinglePrev,{opacity:0});
            //gsap.set(this.pageSingleNext,{opacity:0});
            /*gsap.set(this.pageLeft,{opacity:0});
            gsap.set(this.pageRight,{opacity:0});
            gsap.set(this.pageLeftNext,{opacity:0});
            gsap.set(this.pageRightNext,{opacity:0});
            gsap.set(this.pageRightPrev,{opacity:0});
            gsap.set(this.pageLeftPrev,{opacity:0});*/
            for(let i = 0; i < loadList.length; i++) {
                const target = targetList[i];
                const file = loadList[i];
                if(!file) {
                    loadCompNum++;
                    target.innerHTML = '';
                } else {
                    const page = new Page(i);
                    page.load(this.dist + file,target);
                    target.addEventListener('loadend',loadEnd);
                }

            }

        }
        loadStart();


    }


    /*=======================================

   　両面ページを読み込む

    =======================================*/
    setSidesPage(n) {
        const loadListCurrent = this.pageList[n];
        const loadListPrev = this.pageList[n - 1] || [null,null];
        const loadListNext = this.pageList[n + 1] || [null,null];
        const loadList = loadListCurrent.concat(loadListPrev,loadListNext);
        const targetList = [
            this.pageLeft,
            this.pageRight,
            this.pageLeftPrev,
            this.pageRightPrev,
            this.pageLeftNext,
            this.pageRightNext
        ];
        const event = new Event('pageload');
        this.book.dispatchEvent(event);
        let loadCompNum = 0;

        gsap.set(this.pageLeftClone,{opacity:1,zIndex:5});
        gsap.set(this.pageRightClone,{opacity:1,zIndex:5});



        //読み込み完了
        const loadEnd = () => {
            const leftTurnArea = this.pageLeft.querySelector('.js-turn-area-left');
            const rightTurnArea = this.pageRight.querySelector('.js-turn-area-right');
            loadCompNum++;
            if(loadCompNum === loadList.length) {
                this.isEnable = true;
                this.currentPageNum = n;
                //初期の状態にする
                gsap.set(this.pageLeft,{zIndex:2,rotateY: '0deg',filter:'brightness(100%)',opacity:1});
                gsap.set(this.pageRight,{zIndex:2,rotateY: '0deg',filter:'brightness(100%)',opacity:1});
                gsap.set(this.pageLeftNext,{zIndex:3,rotateY:'90deg',filter:'brightness(80%)',opacity:1});
                gsap.set(this.pageRightNext,{zIndex:1,rotateY:'0deg',filter:'brightness(100%)',opacity:1});
                gsap.set(this.pageRightPrev,{zIndex:3,rotateY:'-90deg',filter:'brightness(80%)',opacity:1});
                gsap.set(this.pageLeftPrev,{zIndex:1,rotateY:'0deg',filter:'brightness(100%)',opacity:1});
                gsap.set(this.pageRightClone,{opacity:0});
                gsap.set(this.pageLeftClone,{opacity:0});
                this.pageLeftClone.innerHTML = '';
                this.pageRightClone.innerHTML = '';
                this.btnActive(this.pageLeft);
                this.btnActive(this.pageRight);
                if(leftTurnArea) {
                    leftTurnArea.classList.add('pointer');
                    leftTurnArea.addEventListener('click',() => {
                        if(this.zoom.isZoom) return;
                        this.pagePrev();
                    })
                }
                if(rightTurnArea && this.currentPageNum !== this.maxPageNum-1) {
                    rightTurnArea.classList.add('pointer');
                    rightTurnArea.addEventListener('click',() => {
                        if(this.zoom.isZoom) return;
                        this.pageNext();
                    })
                }
               //this.setPageNum();
            }
        }

        //読み込み開始
        const loadStart = () => {
            gsap.set(this.pageLeft,{opacity:0});
            gsap.set(this.pageRight,{opacity:0});
            gsap.set(this.pageLeftNext,{opacity:0});
            gsap.set(this.pageRightNext,{opacity:0});
            gsap.set(this.pageRightPrev,{opacity:0});
            gsap.set(this.pageLeftPrev,{opacity:0});
            for(let i = 0; i < loadList.length; i++) {
                const target = targetList[i];
                const file = loadList[i];
                if(!file) {
                    loadCompNum++;
                    target.innerHTML = '';
                } else {
                    const page = new Page(i);
                    page.load(this.dist + file,target);
                    target.addEventListener('loadend',loadEnd);
                }

            }

        }
        loadStart();
    }


    /*=======================================

    指定ページへ移動

    =======================================*/
    pageJump(n,dir) {
        if(this.getMedia()) {
            this.pageSingleJump(n,dir);
        } else {
            this.pageSidesJump(n,dir);
        }

    }

    //両面の場合
    pageSidesJump(n,dir) {
        if(this.currentPageNum === n || !this.isEnable) return;
        this.isEnable = false;
        this.dir = dir;
        const loadList = this.pageList[n];
        const targetList = n > this.currentPageNum ? [this.pageLeftNext,this.pageRightNext] : [this.pageLeftPrev,this.pageRightPrev];
        let loadCompNum = 0;


        const loadEnd = () => {
            loadCompNum++;
            if(loadCompNum === loadList.length) {
                if(n > this.currentPageNum) this.startNextTurn();
                else this.startPrevTurn();
                this.currentPageNum = n;
            }

        }

        //読み込み開始
        const loadStart = () => {
            for(let i = 0; i < loadList.length; i++) {
                const target = targetList[i];
                const file = loadList[i];
                if(!file) {
                    loadCompNum++;
                    target.innerHTML = '';
                } else {
                    const page = new Page();
                    page.load(this.dist + file,target);
                    target.addEventListener('loadend',loadEnd);
                }

            }

        }
        loadStart();
    }

    //片面の場合
    pageSingleJump(n,d) {
        if((this.currentPageNum === n && this.dir === d) || !this.isEnable) return;
        let newDir;
        if(n > this.currentPageNum) newDir = 'next';
        else if(n < this.currentPageNum) newDir = 'prev';
        else {
            if(d === 'right') newDir = 'next';
            else newDir = 'prev';
        }
        this.isEnable = false;
        this.dir = d;

        const p = this.getSingleNum(n);

        const file = this.singlePageList[p];
        const target = newDir === 'next' ? this.pageSingleNext : this.pageSinglePrev;
        //let loadCompNum = 0;

        const loadEnd = () => {
            target.removeEventListener('loadend',loadEnd);
            if(newDir === 'next') this.startNextTurnSingle();
            else this.startPrevTurnSingle();
            this.currentPageNum = n;

        }
        //読み込み開始
        const loadStart = () => {
            const page = new Page();
            page.load(this.dist + file,target);
            target.addEventListener('loadend',loadEnd);
        }
        loadStart();
    }

    /*=======================================

    マウス操作でページめくり

    =======================================*/
    setPageTurn() {
        const r = 2.5;
        const c = 0.15;
        let x1 = 0;
        let x2 = 0;
        let p = 0;

        //左ページ移動
        const leftMove = () => {
            if(p > 0 && p < 0.9) {
                this.prevTL.progress(p);
            }
        }

        //左ページ終わり
        const leftEnd = () => {
            if(p > 0) {
                if(p > c) this.pagePrev();
                 else this.prevTL.reverse();
            }
        }

        //右ページ移動
        const rightMove = () => {
            if(p > 0 && p < 0.9) {
                if(this.maxPageNum !== this.currentPageNum + 1) {
                    this.nextTL.progress(p);

                }
            }
        }

        //右ページ終わり
        const rightEnd = () => {
            if(p > 0) {
                if(p > c) this.pageNext();
                 else this.nextTL.reverse();
            }
        }

        //左ページの操作
        const onLeftMouseDown = (e) => {
            if(this.zoom.isZoom || (this.getMedia() && this.dir ==='right') ) return;
            e.preventDefault();
            p = 0;
            x2 = 0;
            x1 = e.pageX;
            document.addEventListener('mousemove',onLeftMouseMove);
            document.addEventListener('mouseup',onLeftMouseUp);
        }
        const onLeftTouchStart = (e) => {
            if(e.touches.length > 1) {
                leftEnd();
                document.removeEventListener('touchmove',onLeftTouchMove);
                document.removeEventListener('touchend',onLeftTouchEnd);
            }
            if(this.zoom.isZoom || (this.getMedia() && this.dir ==='right') || e.touches.length > 1) return;
            p = 0;
            x2 = 0;
            x1 = e.touches[0].clientX;
            document.addEventListener('touchmove',onLeftTouchMove);
            document.addEventListener('touchend',onLeftTouchEnd);
        }

        const onLeftMouseMove = (e) => {
            e.preventDefault();
            x2 = -x1 + e.pageX;
            p = (x2/this.getPageW()) / r;
            leftMove();

        }
        const onLeftTouchMove = (e) => {
            x2 = -x1 + e.touches[0].clientX;
            p = (x2/this.getPageW()) / r;
            leftMove();
        }

        const onLeftMouseUp = (e) => {
            e.preventDefault();
            leftEnd();
            document.removeEventListener('mousemove',onLeftMouseMove);
            document.removeEventListener('mouseup',onLeftMouseUp);
        }
        const onLeftTouchEnd = (e) => {
            leftEnd();
            document.removeEventListener('touchmove',onLeftTouchMove);
            document.removeEventListener('touchend',onLeftTouchEnd);
        }
        this.pageLeft.addEventListener('mousedown',onLeftMouseDown);
        this.pageLeft.addEventListener('touchstart',onLeftTouchStart);

         //右ページの操作
         const onRightMouseDown = (e) => {
            if(this.zoom.isZoom || (this.getMedia() && this.dir ==='left')) return;
            e.preventDefault();
            p = 0;
            x2 = 0;
            x1 = e.pageX;
            document.addEventListener('mousemove',onRightMouseMove);
            document.addEventListener('mouseup',onRightMouseUp);
        }
        const onRightTouchStart = (e) => {
            if(e.touches.length > 1) {
                rightEnd();
                document.removeEventListener('touchmove',onRightTouchMove);
                document.removeEventListener('touchend',onRightTouchEnd);
            }
            if(this.zoom.isZoom || (this.getMedia() && this.dir ==='left') || e.touches.length > 1) return;
            p = 0;
            x2 = 0;
            x1 = e.touches[0].clientX;
            document.addEventListener('touchmove',onRightTouchMove);
            document.addEventListener('touchend',onRightTouchEnd);
        }

        const onRightMouseMove = (e) => {
            e.preventDefault();
            x2 = x1 - e.pageX;
            p = (x2/this.getPageW()) / r;
            rightMove();
        }
        const onRightTouchMove = (e) => {
            x2 = x1 - e.touches[0].clientX;
            p = (x2/this.getPageW()) / r;
            rightMove();
        }

        const onRightMouseUp = (e) => {
            e.preventDefault();
            rightEnd();
            document.removeEventListener('mousemove',onRightMouseMove);
            document.removeEventListener('mouseup',onRightMouseUp);
        }
        const onRightTouchEnd = (e) => {
            rightEnd();
            document.removeEventListener('touchmove',onRightTouchMove);
            document.removeEventListener('touchend',onRightTouchEnd);
        }
        this.pageRight.addEventListener('mousedown',onRightMouseDown);
        this.pageRight.addEventListener('touchstart',onRightTouchStart);
    }

    /*=======================================

    マウス操作ページめくり片面

    =======================================*/
    setPageTurnSingle() {
        const r = 0.5;
        const c = 0.1;
        let x1 = 0;
        let x2 = 0;
        let p = 0;
        const d = 300;

        const move = () => {
            if(p > 0 && p <= 0.9 ) {
                if(!(this.currentPageNum === 0 && this.dir === 'right')) this.prevSingleTL.progress(Math.abs(p));
            } else if(p < 0 && p >= -0.9) {
                if(!(this.currentPageNum === this.maxPageNum-1 && this.dir === 'right')) this.nextSingleTL.progress(Math.abs(p));
            }
        }

        //左ページ終わり
        const end = () => {
            if(p > 0) {
                if(p > c) this.pagePrev();
                else this.prevSingleTL.reverse();
            } else {
                if(p < -c) this.pageNext();
                else this.nextSingleTL.reverse();
            }
        }
        //現在のページダウン
        const onCurrentMouseDown = (e) => {
            if(this.zoom.isZoom) return;
            e.preventDefault();
            p = 0;
            x2 = 0;
            x1 = e.pageX;
            document.addEventListener('mousemove',onCurrentMouseMove);
            document.addEventListener('mouseup',onCurrentMouseEnd);
        }
        const onCurrentTouchStart = (e) => {
            if(e.touches.length > 1) {
                end();
                document.removeEventListener('touchmove',onCurrentTouchMove);
                document.removeEventListener('touchend',onCurrentTouchEnd);

            }
            if(this.zoom.isZoom || e.touches.length > 1) return;
            p = 0;
            x2 = 0;
            x1 = e.touches[0].clientX;
            document.addEventListener('touchmove',onCurrentTouchMove);
            document.addEventListener('touchend',onCurrentTouchEnd);
        }

        const onCurrentMouseMove = (e) => {
            e.preventDefault();
            x2 = -x1 + e.pageX;
            //x2 *= 0.1;
            p = (x2/this.getSinglePageW()) / r;
            p *= 0.2;
            move();
        }

        const onCurrentTouchMove = (e) => {
            x2 = -x1 + e.touches[0].clientX;
            //x2 *= 0.1;
            p = (x2/this.getSinglePageW()) / r;
            p *= 0.2;
            move();

        }

        const onCurrentMouseEnd = (e) => {
            e.preventDefault();
            end();
            document.removeEventListener('mousemove',onCurrentMouseMove);
            document.removeEventListener('mouseup',onCurrentMouseEnd);

        }

        const onCurrentTouchEnd = (e) => {
            end();
            document.removeEventListener('touchmove',onCurrentTouchMove);
            document.removeEventListener('touchend',onCurrentTouchEnd);

        }

        this.pageSingleCurrent.addEventListener('mousedown',onCurrentMouseDown);
        this.pageSingleCurrent.addEventListener('touchstart',onCurrentTouchStart);
    }


    //次のページへ
    pageNext() {
        if(!this.isEnable) return;
        this.isEnable = false;
        if(this.getMedia()) {
            if(this.currentPageNum === this.maxPageNum - 1 && this.dir === 'right') {
                this.isEnable = true;
            } else {
                if(this.dir === 'right') {
                    this.dir = 'left';
                    this.currentPageNum++
                } else {
                    this.dir = 'right';
                }
                this.startNextTurnSingle();
            }
        } else {
            if(this.currentPageNum === this.maxPageNum - 1) {
                this.isEnable = true;
            } else {
                this.currentPageNum++
                this.startNextTurn();
            }
        }
    }

    //前のページへ
    pagePrev() {
        if(!this.isEnable || this.currentPageNum === 0) return;
        this.isEnable = false;
        if(this.getMedia()) {
            if(this.dir === 'left') {
                this.currentPageNum--;
                this.dir = 'right';
            } else {
                this.dir = 'left';
            }
            this.startPrevTurnSingle();

        } else {
            this.currentPageNum--;
            this.startPrevTurn();
        }

    }



}

//module.exports = new Pamphlet();